import { AppDispatch } from "../../ReduxToolkit/Store";

export const dispatchMultiple = (
  dispatch: AppDispatch,
  actions: Array<() => any>,
  callback?: () => void
) => {
  actions.forEach((action) => dispatch(action()));
  callback?.();
};
